// CRM layer — "حفظ العميل" modal for a call row.
// Thin shell around the shared CrmClientNameForm.

import React from 'react';
import CrmClientNameForm from './CrmClientNameForm';

const CrmSaveClientModal = ({ phoneNumber, initialName, onClose, onSaved }) => (
  <div className="modal-overlay" onClick={onClose}>
    <div className="modal crm-scope" style={{ maxWidth: 460 }} onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h2>حفظ ملف العميل</h2>
        <button className="modal-close" onClick={onClose}>×</button>
      </div>
      <CrmClientNameForm
        phoneNumber={phoneNumber}
        initialName={initialName}
        submitLabel="حفظ الملف"
        note="سيتم إنشاء ملف لهذا الرقم في سجل العملاء، ويمكن بعدها فتح الطلبات له."
        onSaved={(client) => { if (onSaved) onSaved(client); onClose(); }}
        onCancel={onClose}
      />
    </div>
  </div>
);

export default CrmSaveClientModal;
